import type { ApiResource } from '@/core/models/api-resource.interface';
import { http } from '@/core/helpers/http.helper';
import type { AiMatchingRun, AiMatchingRunStatus, AiPosition, AiPositionCandidate, PostAiPositionPayload } from './ai-matching.interface';

export async function getAiPositions(): Promise<Array<AiPosition>> {
   const response = await http.get<ApiResource<Array<AiPosition>>>('/ai-positions');
   return response.data.data ?? [];
}

export async function postAiPosition(payload: PostAiPositionPayload): Promise<AiPosition> {
   const response = await http.post<ApiResource<AiPosition>>('/ai-positions?include=positions', payload);
   return response.data.data;
}

export async function startAiMatching(positionId: string): Promise<AiMatchingRun> {
   // TODO: fix hardcoded payload, api required ??
   const response = await http.post<AiMatchingRun>(`/ai-matching/positions/${positionId}/start-matching`, {
      recruiter_notes: 'find the best candidates for this position',
      use_rescore: true,
   });

   return response.data;
}

export async function getAiMatchingRun(positionId: string, runId: number): Promise<AiMatchingRunStatus> {
   const response = await http.get<AiMatchingRunStatus>(`/ai-matching/positions/${positionId}/match-runs/${runId}`);
   return response.data;
}

export async function getAiPositionCandidates(
   aiPositionId: number,
   tenantSyncId: string,
   positiveVote: boolean | null = null,
): Promise<Array<AiPositionCandidate>> {
   const voteRoute = positiveVote === null ? '' : positiveVote ? '/liked' : '/disliked';
   const response = await http.get<ApiResource<Array<AiPositionCandidate>>>(`/ai-positions/${aiPositionId}/candidates${voteRoute}`, {
      params: {
         tenant_id: tenantSyncId,
         positive_vote: positiveVote,
      },
   });

   return response.data.data ?? [];
}

export async function voteAiPositionCandidate(
   aiPositionId: number,
   candidateId: string,
   positiveVote: boolean,
): Promise<{ count: number; liked_count: number; disliked_count: number }> {
   const response = await http.post<{ count: number; liked_count: number; disliked_count: number }>(
      `/ai-positions/${aiPositionId}/candidates/${candidateId}/vote`,
      { positive_vote: positiveVote },
   );

   return { count: response.data.count, liked_count: response.data.liked_count, disliked_count: response.data.disliked_count };
}

export async function deleteAiPosition(id: number): Promise<void> {
   await http.delete(`/ai-positions/${id}`);
}

export async function submitAnalyseFeedback(
   aiPositionId: number,
   candidateId: string,
   snapshotId: number,
   vote: boolean,
   comment: string | null,
): Promise<void> {
   await http.post(`/ai-positions/${aiPositionId}/candidates/${candidateId}/analyse-feedback`, {
      snapshot_id: snapshotId,
      vote,
      comment: comment || null,
   });
}
